export default __webpack_public_path__ + "static/home_page_ordering-085703299b88bb0d569e19c20bb8925c.mp4";